/**
 * @owner @Appboy/messaging-experience
 */
import { customEventRemoteLookupValidators } from "../.generated/customEventRemoteLookup";
import type { CustomEventRemoteLookupProvider } from "../.generated/customEventRemoteLookup";

export const customEventProvider: CustomEventRemoteLookupProvider = {
  mapItemToId: (item) => item.indexed_name,
  mapIdToString: (id) => id,
  mapItemToSearchString: (item) => item.name,
  validators: customEventRemoteLookupValidators,
};
